import {
    IWatchedItem,
    IWatcher,
    ProSettingsGetResponse,
    Ulid,
} from "@kase/my-marathon-communication";
import { signal } from "@preact/signals";
import { ApiSliceParams } from "../interfaces";

const DEFAULT_PRO_SETTINGS = {
    _id: Ulid.ZERO,
    id: Ulid.ZERO.toString(),
    time: {
        allow_all_groups: true,
    },
};

export const makePro = ({ connection, company }: ApiSliceParams) => {
    const loading = signal(false);
    const loaded = signal(false);
    const store = signal(DEFAULT_PRO_SETTINGS);
    let watcher: IWatcher<IWatchedItem<Ulid, ProSettingsGetResponse>> | null =
        null;

    const listen = () => {
        if (watcher) {
            return;
        }

        const con = connection.value;

        loading.value = true;

        watcher = con.prosettings.get({ company: company.value });

        watcher.listen((value) => {
            const result = value.item;

            if (result) {
                const newValue = {
                    id: result.id.toString(),
                    _id: result.id,
                    time: {
                        allow_all_groups: result.time?.allow_all_groups ?? true,
                    },
                };

                store.value = newValue;
            } else {
                store.value = DEFAULT_PRO_SETTINGS;
            }

            if (!loaded.peek()) {
                loaded.value = true;
                loading.value = false;
            }

            return true;
        });
    };

    return {
        store,
        listen,
    };
};
